/* istanbul ignore file */
import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { CurriculumRouteContentGetter } from 'layers/content/v3/Hocs/CurriculumRouteContentGetter'
import withSiteContext from 'layers/content/v2/Hocs/withSiteContext'
import withApiError from 'layers/errorHandling/apiError'
import { navigationEvent } from 'layers/navigation/store/operations'
import { getPageTypeByUrl } from 'utils/routing/getPageTypeByUrl'
import {
  resolveRouteServiceApp,
  resolveDwbProgramSupportsArticleSlug,
} from 'utils/routing/routeHelpers'

import ResourcesSubLandingPageV3 from './component'

const mapSubsectionLanding = (entry, location, navigationEventFn) => {
  const { displayTitle, description, content = [] } = entry || {}

  const articles = content.map(article => {
    const { description: body, displayTitle: title, pageData } = article || {}
    const { image } = article || {}
    const { image: image2 } = image || {}
    const { url } = image2 || {}
    const slug = resolveDwbProgramSupportsArticleSlug(
      pageData?.route || article?.route || article?.metadata?.route,
    )

    return {
      body,
      image: url,
      link: slug,
      location,
      navigationEvent: navigationEventFn,
      title,
    }
  })

  return {
    articles,
    banner: { text: description, title: displayTitle },
  }
}

export const ResourcesSubLandingPageV3Container = props => {
  const {
    location,
    navigationEvent: navigationEventFn,
    routeContent,
    productTabTitle,
  } = props || {}

  const { content = {}, loading } = routeContent || {}
  const { subsectionLanding } = content
  const readyToLoad = !!content && !loading

  if (!readyToLoad || !subsectionLanding) {
    return null
  }

  const pageType = getPageTypeByUrl(location?.pathname)
  const parsedEntry = mapSubsectionLanding(
    subsectionLanding,
    location,
    navigationEventFn,
  )

  return (
    <ResourcesSubLandingPageV3
      pageType={pageType}
      productTabTitle={productTabTitle}
      {...parsedEntry}
      navigationEvent={navigationEventFn}
    />
  )
}

ResourcesSubLandingPageV3Container.propTypes = {
  location: PropTypes.object,
  navigationEvent: PropTypes.func,
  productTabTitle: PropTypes.string,
  routeContent: PropTypes.object,
}

const mapStateToProps = state => ({
  productTabTitle: state.productManager?.productMap?.name || '',
})

const mapDispatchToProps = {
  navigationEvent,
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: match => match?.url || window?.location?.pathname,
}

export default withSiteContext(
  CurriculumRouteContentGetter(
    withApiError(
      connect(
        mapStateToProps,
        mapDispatchToProps,
      )(ResourcesSubLandingPageV3Container),
    ),
    options,
  ),
  { syncSiteQueryParam: false },
)
